export enum ReIssueInvoiceDate {
    DueDate = 1,
    OriginalIssue = 2,
}
